<script>

	import { fade, slide } from 'svelte/transition';
	import { menuOpen } from '../stores.js';
	import { scrollToElement } from '../utilities.js';
	import Logo from './Logo.svelte';
	import Navigation from './Navigation.svelte';
	import Checkbox from './Checkbox.svelte';

	export let site;

	function stopScrolling(){
		document.body.classList.add('no-scrolling');
	}
	function startScrolling(){
		document.body.classList.remove('no-scrolling');
	}

	function toggleBodyClass( state ){
		if( state ){
			scrollToElement('#mobile-navigation');
			stopScrolling();
		} else {
			startScrolling();
		}
	}
	$: toggleBodyClass( $menuOpen );

	let headerHeight = 10;
	let header;
	function getHeaderHeight( el ){
		header = header || el;
		var styles = window.getComputedStyle(el);
		var margin = parseFloat(styles['marginTop']) + parseFloat(styles['marginBottom']);
		headerHeight = header.offsetHeight + margin;
		// update global css variable
		document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
	}

	$: console.log( headerHeight );

</script>

<header id="mobile-navigation" class="text-l" bind:this={header} use:getHeaderHeight>
	
	<div class="title">
		<Logo title={site.title} />
		<Checkbox title="Menu" bind:checked={$menuOpen} />
	</div>

	{#if $menuOpen}
		<div class="navigation" transition:slide>
			<div class="space"></div>
			<Navigation filters={site.filters} />
		</div>
	{/if}

</header>

{#if $menuOpen}
	<div transition:fade class="glass" on:pointerdown={()=> menuOpen.set(false) }></div>
{/if}

<style>

	header {
		position: sticky;
		top: 0;
		left: 0;
		width: 100%;
		z-index: 100;
		background: var(--background);
		padding: 1rem;
	}

	.title {
		display: flex;
		justify-content: space-between;
	}

	.space {
		height: 1rem;
	}

	.glass {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
		background-color: var(--text-color);
		opacity: 0.3;
		cursor: n-resize;
	}

</style>